export default __webpack_public_path__ + "static/media/Audi A3.803ecc26.jpg";